import { render, staticRenderFns } from "./AgoHandler.vue?vue&type=template&id=5765272d&scoped=true"
import script from "./AgoHandler.vue?vue&type=script&lang=js"
export * from "./AgoHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5765272d",
  null
  
)

export default component.exports